import { sessionHeaders } from "./api";

/**
 * Sends browser errors to the server log (POST /api/client-log), so problems on someone's
 * phone or PC can be debugged from the log files. Duplicate errors are only sent once.
 */
type Kind = "error" | "unhandledrejection" | "react";

const sent = new Set<string>();

export function reportError(kind: Kind, error: unknown) {
    const err = error instanceof Error ? error : new Error(String(error));
    const key = `${kind}:${err.message}`;
    if (sent.has(key) || sent.size > 50) return;
    sent.add(key);
    try {
        void fetch("/api/client-log", {
            method: "POST",
            headers: { "content-type": "application/json", ...sessionHeaders() },
            body: JSON.stringify({
                kind,
                message: err.message.slice(0, 2000),
                stack: err.stack?.slice(0, 8000),
                url: location.href.slice(0, 1000),
            }),
            keepalive: true,
        }).catch(() => {
            // Reporting is best-effort; never let it cause more errors.
        });
    } catch {
        // Same as above.
    }
}

export function installErrorReporting() {
    globalThis.addEventListener("error", (e) => {
        const { error, message } = e as ErrorEvent;
        reportError("error", error ?? message);
    });
    globalThis.addEventListener("unhandledrejection", (e) => reportError("unhandledrejection", (e as PromiseRejectionEvent).reason));
}
